import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";

const StyledFooter = styled(Box)`
	background-color: #FFFFFF;
	border-top: 1px solid #E9EAEB;
	padding: ${(props) => props.theme.spacing(2)} ${(props) => props.theme.spacing(3)};
	margin-top: auto;
`;

export const Footer = () => {
	const currentYear = new Date().getFullYear();

	return (
		<StyledFooter>
			<Typography variant="body2" color="text.secondary" textAlign="center">
				© {currentYear} Swiss Life Select. Všechna práva vyhrazena.
			</Typography>
		</StyledFooter>
	);
};
